import { useState, useEffect } from 'react'

interface AuditLog {
  id: string
  action: string
  targetType: string
  targetId: string | null
  severity: string
  reason: string | null
  createdAt: string
  actorEmail: string | null
}

export function AdminAuditLogsPage() {
  const [logs, setLogs] = useState<AuditLog[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/admin/audit-logs')
      .then(res => res.json())
      .then((json: any) => {
        if (json.success) setLogs(json.data)
        setLoading(false)
      })
  }, [])

  if (loading) return <div className="text-slate-500">Loading audit logs...</div>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-100">Audit Logs</h1>
        <p className="text-sm text-slate-400 mt-1">System-wide record of sensitive actions.</p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-800/50 text-slate-400 border-b border-slate-800">
            <tr>
              <th className="px-6 py-3 font-medium">Timestamp</th>
              <th className="px-6 py-3 font-medium">Actor</th>
              <th className="px-6 py-3 font-medium">Action</th>
              <th className="px-6 py-3 font-medium">Target</th>
              <th className="px-6 py-3 font-medium">Severity</th>
              <th className="px-6 py-3 font-medium">Reason</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {logs.map(log => (
              <tr key={log.id} className="hover:bg-slate-800/20 transition-colors">
                <td className="px-6 py-4 text-slate-400">{new Date(log.createdAt).toLocaleString()}</td>
                <td className="px-6 py-4 text-slate-300">{log.actorEmail || 'System'}</td>
                <td className="px-6 py-4 font-medium text-slate-200">{log.action}</td>
                <td className="px-6 py-4 text-slate-400">
                  {log.targetType} <span className="text-xs text-slate-600 block">{log.targetId || '-'}</span>
                </td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase ${
                    log.severity === 'critical' ? 'bg-rose-500/10 text-rose-400 border border-rose-500/20' :
                    log.severity === 'warning' ? 'bg-amber-500/10 text-amber-400 border border-amber-500/20' :
                    'bg-blue-500/10 text-blue-400 border border-blue-500/20'
                  }`}>
                    {log.severity}
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-400">{log.reason || '-'}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr>
                <td colSpan={6} className="px-6 py-8 text-center text-slate-500">No audit logs found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
